import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
});
